/* Iceberg */
import { Flex } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';
import GoogleLogo from 'images/Google_G_Logo.svg';
import ADLogo from 'images/Microsoft-entra-id-logo.png';
import React from 'react';

export const IntegrationMethodIcon = ({ type }) => {
    const theme = useTheme();
    const img = type === 'microsoftEntraID' ? ADLogo : GoogleLogo;
    return (
        <Flex
            backgroundColor={theme.palette.background.integrationMethodIcon}
            borderRadius="100%"
            width="60px"
            height="60px"
            alignItems="center"
            justifyContent="center"
            alignSelf="center"
            mb={3}
            flexShrink="0"
        >
            <img
                src={img}
                alt={`icon_${type}`}
                height="32px"
                data-testid={`${type}_image`}
            />
        </Flex>
    );
};
